import { render, staticRenderFns } from "./statementDc.vue?vue&type=template&id=28d34f2e&scoped=true"
import script from "./statementDc.vue?vue&type=script&lang=js"
export * from "./statementDc.vue?vue&type=script&lang=js"
import style0 from "./statementDc.vue?vue&type=style&index=0&id=28d34f2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d34f2e",
  null
  
)

export default component.exports